// import styles from './../../src/abstracts/_spacings.scss';
const styles = {
  spacingNone: 0,
  spacingXs: 4,
  spacingLs: 6,
  spacingS: 8,
  spacingMs: 12,
  spacingM: 16,
  spacingMl: 24,
  spacingL: 32,
  spacingLx: 48,
  spacingXl: 64,
  spacingX2L: 128,
  spacingX3L: 256,
  spacingCM: 40,
  spacingCL: 44,
  spacingCXl: 48,
  spacingCX2L: 52,
  spacingCX3L: 56,
  spacings: {
    '0': 0,
    xs: 4,
    ls: 6,
    s: 8,
    m: 16,
    ms: 12,
    ml: 24,
    l: 32,
    lx: 48,
    xl: 64
  },
  spacingsC: { m: 40, l: 44, xl: 48 },
  spacingPosition: [ 'top', 'right', 'bottom', 'left' ]
}

export const spacingsC = styles.spacingsC;

export default styles.spacings;